<template>
    <el-dialog :title="titleName" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-input v-model="form.zhangTaoId" autocomplete="off" style="display: none;"></el-input>
            <el-form-item label="科目ID" :label-width="formLabelWidth" :required="true" prop="keMuId">
                <el-input v-model="form.keMuId" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="期初余额(分)" :label-width="formLabelWidth" :required="true" prop="qiChuValue">
                <el-input v-model="form.qiChuValue" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="本年累计借方(分)" :label-width="formLabelWidth" :required="true" prop="bnljJfValue">
                <el-input v-model="form.bnljJfValue" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="本年累计贷方(分)" :label-width="formLabelWidth" :required="true" prop="bnljDfValue">
                <el-input v-model="form.bnljDfValue" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="科目分类" :label-width="formLabelWidth" :required="true" prop="leiBie">
                <el-input v-model="form.leiBie" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="年初余额(分)" :label-width="formLabelWidth" :required="true" prop="nianChuValue">
                <el-input v-model="form.nianChuValue" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="实际损益发生额(分)" :label-width="formLabelWidth" :required="true" prop="shiJiSunYiValue">
                <el-input v-model="form.shiJiSunYiValue" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="科目代码" :label-width="formLabelWidth" :required="true" prop="kmdm">
                <el-input v-model="form.kmdm" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                url: '',
                titleName: '',
                form: {
                    zhangTaoId: '',
                    keMuId: '',
                    qiChuValue: '',
                    bnljJfValue: '',
                    bnljDfValue: '',
                    leiBie: '',
                    nianChuValue: '',
                    shiJiSunYiValue: '',
                    kmdm: ''
                },
                rules: {
                    zhangTaoId: [{required: true, message: '请输入账套ID', trigger: 'blur'}],
                    keMuId: [{required: true, message: '请输入科目ID', trigger: 'blur'}],
                    qiChuValue: [{required: true, message: '请输入期初余额(分)', trigger: 'blur'}],
                    bnljJfValue: [{required: true, message: '请输入本年累计借方(分)', trigger: 'blur'}],
                    bnljDfValue: [{required: true, message: '请输入本年累计贷方(分)', trigger: 'blur'}],
                    leiBie: [{required: true, message: '请输入科目分类', trigger: 'blur'}],
                    nianChuValue: [{required: true, message: '请输入年初余额(分)', trigger: 'blur'}],
                    shiJiSunYiValue: [{required: true, message: '请输入实际损益发生额(分)', trigger: 'blur'}],
                    kmdm: [{required: true, message: '请输入科目代码', trigger: 'blur'}]
                },
                formLabelWidth: '120px'
            };
        },
        methods: {
            int(id) {
                this.$refs['ruleForm'].resetFields();
                this.dialogFormVisible = true;
                this.form.zhangTaoId = '';
                this.form.keMuId = '';
                this.form.qiChuValue = '';
                this.form.bnljJfValue = '';
                this.form.bnljDfValue = '';
                this.form.leiBie = '';
                this.form.nianChuValue = '';
                this.form.shiJiSunYiValue = '';
                this.form.kmdm = '';

                if (id == 'add') {
                    this.titleName = "财务初始余额-新增";
                    this.url = "/business/initialFinancialBalance/save";
                } else {
                    this.titleName = "财务初始余额-修改";
                    this.url = "/business/initialFinancialBalance/update";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/initialFinancialBalance/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                    }).finally(r => {
                    })
                }
            },
            addAndUpdate(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("handleCurrentChange", 1);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
</style>
